export const FUNNEL = {
  SEND: 'SEND',
  REQUEST: 'REQUEST',
  CONTACT: 'CONTACT',
  MORE: 'MORE',
}

export const PRODUCT_FLOWS = {
  REQUEST: 'REQUEST_MONEY',
  SEND: 'SEND_MONEY',
}

export const PAYMENT_PROCESSORS = {
  PAYPAL: 'PAYPAL',
  XOOM: 'XOOM',
}

/**
 * @IMPORTANT
 * ENV_TYPE !== ANALYTICS_FLOW_TYPE
 * Environment types should be used for external flows and integrations and can
 * alter the experience, such as "/myaccount/transfer/homepage/external/donate".
 */
export const ENV_TYPE = {
  PP_ME: 'ppme',
  PROFILE: 'profile',
  DONATE: 'donate',
  PAY_REQUEST: 'payRequest',
  PAR: 'par',
  SUMMARY: 'summary',
  POOLS: 'pools',
  WALLET: 'wallet',
  MGM: 'mgm',
  MESSAGES: 'messages',
  PPSHOPS: 'shops',
  PISP: 'pisp',
  OUTLOOK: 'outlook',
  CROSS_BORDER: 'xb',
  HAWK: 'hawk',
  HAWK_PPCP: 'hawk-ppcp',
  MPP: 'mpp',
  TRICOUNT: 'tricount',
  MARKETING: 'marketing',
  NATIVE_MERCHANT: 'nativeMerchant',
  SPLIT: 'split',
  HOME_INFO: 'homeinfo',
}

/**
 * @IMPORTANT
 * ANALYTICS_FLOW_TYPE !== ENV_TYPE
 * Analytics flow types are used for instrumentation purposes to identify where
 * the user is "originatedFrom", as well as for "product_flow.identifier" used
 * for assess capabilities. For example: "/myaccount/transfer?from=Header".
 */
export const ANALYTICS_FLOW_TYPE = {
  PP_ME: 'ppme',
  PROFILE: 'profile',
  DONATE: 'donate',
  PAY_REQUEST: 'payRequest',
  PAR: 'par',
  SUMMARY: 'summary',
  POOLS: 'pools',
  ACTIVITY: 'Activity',
  NAV_HEADER: 'Header',
  SUMMARY_RESEND: 'SUM-QuickSend', // summary send again
  SUMMARY_LINK: 'SUM-QuickLink', // summary quick send button
  CONTROL_SUM: 'ControlSUM',
  MGM: 'mgm',
  MESSAGES: 'messages',
  PPSHOPS: 'shops',
  PISP: 'pisp',
  OUTLOOK: 'outlook',
  TRICOUNT: 'tricount',
  HOME_INFO: 'homeinfo',
  OTHER: 'Other', // unidentified flow
}

export const SHIPPING_TYPES = {
  FLAT_RATE: 'FLAT_RATE',
  FREE: 'FREE',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
}

export const ACCOUNT_TYPE = {
  PERSONAL: 'PERSONAL',
  PREMIER: 'PREMIER',
  BUSINESS: 'BUSINESS',
}

// payment type
export const PAYMENT_TYPE = {
  PURCHASE: 'PURCHASE',
  PERSONAL: 'PERSONAL',
  UNKNOWN: 'UNKNOWN',
  DONATION: 'DONATION',
}

// instrument type
export const INSTRUMENT_TYPES = {
  HOLDING: 'HOLDING',
  PAYMENT_CARD: 'PAYMENT_CARD',
  PAYMENT_TOKEN: 'PAYMENT_TOKEN',
  BANK_ACCOUNT: 'BANK_ACCOUNT',
  CREDIT: 'CREDIT',
  UNKNOWN: 'UNKNOWN',
}

// V2 InstrumentType
export const INSTRUMENT_TYPE = {
  BALANCE: 'BALANCE',
  BANK: 'BANK',
  CARD: 'CARD',
  PAYMENT_TOKEN: 'PAYMENT_TOKEN',
  CREDIT: 'CREDIT',
}

export const BANK_ACCOUNT_TYPE = {
  CURRENT: 'CURRENT',
  SAVINGS: 'SAVINGS',
}

export const FUNDING_SOURCE_TAG = {
  PREFERRED_INSTRUMENT: 'PREFERRED_INSTRUMENT',
  DYNAMIC_CURRENCY_CONVERSION: 'DYNAMIC_CURRENCY_CONVERSION',
  CASH_ADVANCE_FEES_APPLICABLE: 'CASH_ADVANCE_FEES_APPLICABLE',
  PROMO_FINANCING_APPLICABLE: 'PROMO_FINANCING_APPLICABLE',
  PROMO_FINANCING_NOT_APPLICABLE: 'PROMO_FINANCING_NOT_APPLICABLE',
  PROMO_FINANCING_ELIGIBLE: 'PROMO_FINANCING_ELIGIBLE',
  PROMO_FINANCING_INELIGIBLE: 'PROMO_FINANCING_INELIGIBLE',
  INSTRUMENT_DECLINED: 'INSTRUMENT_DECLINED',
}

export const FUNDING_SOURCE_CLIENT_TAGS = {
  INSTRUMENT_DECLINED: 'instrumentDeclined',
}

export const PP_CREDIT_PROMO_STATE = {
  NOT_APPLICABLE: 'NOT_APPLICABLE',
  ELIGIBLE: 'ELIGIBLE',
  INELIGIBLE: 'INELIGIBLE',
}

// analytics call them differently 😂
export const ANALYTIC_TYPE = {
  PURCHASE: 'gs',
  PERSONAL: 'ff',
  UNKNOWN: 'none',
}

export const CONSENT_TYPE = {
  SIGNUP_FOR_NETWORK_ID: 'SIGNUP_FOR_NETWORK_ID',
  PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT:
    'PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT',
  UPGRADE_NETWORK_ID: 'UPGRADE_NETWORK_ID',
  SIGN_UP_FOR_PUBLIC_IDENTITY: 'SIGNUP_FOR_NETWORK_ID',
  PROVIDE_PUBLIC_IDENTITY_CONSENT: 'PROVIDE_ADDITIONAL_NETWORK_ID_CONSENT',
  UPGRADE_PUBLIC_IDENTITY: 'UPGRADE_NETWORK_ID',
}

export const MONEY_PAGE = {
  CONTROL_WEB: 'CONTROL_WEB',
  DEFAULT_ON_REVIEW: 'DEFAULT_ON_REVIEW',
  CTRL_CONTENT_V2_WEB: 'CTRL_CONTENT_V2_WEB', // T12
  CTRL_CONTENT_V2_ORDER_WEB: 'CTRL_CONTENT_V2_ORDER_WEB', // T13
  CTRL_VENMO_CONTENT_MESSAGE_WEB: 'CTRL_VENMO_CONTENT_MESSAGE_WEB', // T14
}

// for historic reasons we call PERSONAL and PURCHASE different things
// this maps different terms
export const transactionTypeMap = {
  PERSONAL: PAYMENT_TYPE.PERSONAL,
  personal: PAYMENT_TYPE.PERSONAL,
  GOODS: PAYMENT_TYPE.PURCHASE,
  goods: PAYMENT_TYPE.PURCHASE,
  PURCHASE: PAYMENT_TYPE.PURCHASE,
  purchase: PAYMENT_TYPE.PURCHASE,
  SEND: PAYMENT_TYPE.PERSONAL,
  send: PAYMENT_TYPE.PERSONAL,
  BUY: PAYMENT_TYPE.PURCHASE,
  buy: PAYMENT_TYPE.PURCHASE,
  FF: PAYMENT_TYPE.PERSONAL,
  ff: PAYMENT_TYPE.PERSONAL,
  GS: PAYMENT_TYPE.PURCHASE,
  gs: PAYMENT_TYPE.PURCHASE,
  UNKNOWN: PAYMENT_TYPE.UNKNOWN,
  unknown: PAYMENT_TYPE.UNKNOWN,
}

export const analyticMap = {
  PERSONAL: ANALYTIC_TYPE.PERSONAL,
  personal: ANALYTIC_TYPE.PERSONAL,
  GOODS: ANALYTIC_TYPE.PURCHASE,
  goods: ANALYTIC_TYPE.PURCHASE,
  PURCHASE: ANALYTIC_TYPE.PURCHASE,
  purchase: ANALYTIC_TYPE.PURCHASE,
  SEND: ANALYTIC_TYPE.PERSONAL,
  send: ANALYTIC_TYPE.PERSONAL,
  BUY: ANALYTIC_TYPE.PURCHASE,
  buy: ANALYTIC_TYPE.PURCHASE,
  FF: ANALYTIC_TYPE.PERSONAL,
  ff: ANALYTIC_TYPE.PERSONAL,
  GS: ANALYTIC_TYPE.PURCHASE,
  gs: ANALYTIC_TYPE.PURCHASE,
  UNKNOWN: ANALYTIC_TYPE.UNKNOWN,
  unknown: ANALYTIC_TYPE.UNKNOWN,
}

export const PAYEE_TYPES = {
  EMAIL: 'EMAIL',
  PHONE: 'PHONE',
  ACCOUNT_NUMBER: 'ACCOUNT_NUMBER',
  PAYPALME_PROFILE: 'PAYPALME_PROFILE', // V1 Only
  PAYPAL_PROFILE: 'PAYPAL_PROFILE', // V2 Only
}

export const PAYEE_TAG = {
  CIP: 'CIP',
  RESTRICTED_ACCOUNT: 'RESTRICTED_ACCOUNT',
}

export const PHONE_TYPE = {
  MOBILE: 'MOBILE',
  HOME: 'HOME',
}

export const CONTINGENCY = {
  CONSENT: 'OBTAIN_REAL_TIME_BALANCE_CONSENT',
  REFRESH: 'REFRESH_REAL_TIME_BALANCE',
  // This is a made up contingency, it is never returned in the plan
  // it is used by us to trigger CONSENT flow while resolving REFRESH contingency.
  // It only happens when resolve(REFRESH) throws CONTINGENCY_ERRORS.INVALID_LOGIN
  INVALID_CREDENTIALS: 'REFRESH_REAL_TIME_BALANCE_INVALID_CREDENTIALS',
}

export const CONTINGENCY_ERRORS = {
  INVALID_LOGIN: 'REFRESH_CONTINGENCY_INVALID_LOGIN_CREDENTIALS',
  UNAVAILABLE: 'PAYER_FUNDING_INSTRUMENTS_UNAVAILABLE',
  DENIED: 'PAYMENT_DENIED',
}

export const FREEP2P_TYPE = {
  NON_EU: 'FREEP2P_NON_EU',
  EU: 'FREEP2P_EU',
  INAPPLICABLE: 'FREEP2P_INAPPLICABLE',
}

export const CREDIT_ACCOUNT_TYPE = {
  BUYER_CREDIT_VIRTUAL_LINE: 'BUYER_CREDIT_VIRTUAL_LINE',
  CLOSE_ENDED: 'CLOSE_ENDED',
  DUAL_CARD_EBAY: 'DUAL_CARD_EBAY',
  DUAL_CARD_PLUS: 'DUAL_CARD_PLUS',
  OPEN_ENDED: 'OPEN_ENDED',
  TXN_CARD_BML: 'TXN_CARD_BML',
  TXN_CARD_PAY_LATER: 'TXN_CARD_PAY_LATER',
  GENERIC_CREDIT: 'GENERIC_CREDIT',
}

export const DISALLOWED_FUNDING_SOURCE_REASONS = {
  RECEIVER_PREFERENCE: 'RECEIVER_PREFERENCE',
  SENDER_PREFERENCE: 'SENDER_PREFERENCE',
  INSTRUMENT_EXPIRED: 'INSTRUMENT_EXPIRED',
  INSTRUMENT_DECLINED: 'INSTRUMENT_DECLINED',
  UNSUPPORTED_PAYMENT_TYPE: 'UNSUPPORTED_PAYMENT_TYPE',
  UNSUPPORTED_CURRENCY: 'UNSUPPORTED_CURRENCY',
  CIP_VERIFICATION_NOT_STARTED: 'CIP_VERIFICATION_NOT_STARTED',
  CIP_VERIFICATION_PENDING_REVIEW: 'CIP_VERIFICATION_PENDING_REVIEW',
}

export const FUNDING_MODE = {
  INSTANT: 'INSTANT',
  DELAYED: 'DELAYED',
}

export const REVIEW_INFO_LABEL_KEYS = {
  ESTIMATED: 'label.estimatedDelivery',
  PAYMENT: 'label.paymentDelivery',
}

export const CONTINGENCY_ACTIONS = {
  USER_DATA_COLLECTION_REQUIRED: 'USER_DATA_COLLECTION_REQUIRED',
  CARD_VERIFICATION_DATA_COLLECTION_REQUIRED:
    'CARD_VERIFICATION_DATA_COLLECTION_REQUIRED',
  PURCHASE_CONSENT_REQUIRED: 'PURCHASE_CONSENT_REQUIRED',
  THREE_D_SECURE_DATA_COLLECTION_REQUIRED:
    'THREE_D_SECURE_DATA_COLLECTION_REQUIRED',
  THREE_D_SECURE_AUTHENTICATION_REQUIRED:
    'THREE_D_SECURE_AUTHENTICATION_REQUIRED',
  OBTAIN_REAL_TIME_BALANCE_CONSENT: 'OBTAIN_REAL_TIME_BALANCE_CONSENT',
  REFRESH_REAL_TIME_BALANCE: 'REFRESH_REAL_TIME_BALANCE',
  TOPUP_INSTRUMENT: 'TOPUP_INSTRUMENT',
  USER_AGREEMENT_CONSENT_REQUIRED: 'USER_AGREEMENT_CONSENT_REQUIRED',
}

export const USER_DATA_COLLECTION_ATTRIBUTES = {
  SENDER_GOVERNMENT_ID: 'SENDER_GOVERNMENT_ID',
  SENDER_ADDRESS: 'SENDER_ADDRESS',
  RECEIVER_NAME: 'RECEIVER_NAME',
  RECEIVER_COUNTRY_CODE: 'RECEIVER_COUNTRY_CODE',
}

export const STORY_ERRORS = {
  // Send message errors
  FAILED_TO_SEND: 'FAILED_TO_SEND',
  FAILED_TO_SEND_NO_RETRY: 'FAILED_TO_SEND_NO_RETRY',
  RESOURCE_NOT_FOUND: 'RESOURCE_NOT_FOUND',
  FIELD_NOT_PATCHABLE: 'FIELD_NOT_PATCHABLE',
  ACCOUNT_LEVEL_RESTRICTION: 'ACCOUNT_LEVEL_RESTRICTION',
  MESSAGE_CONTAINS_SENSITIVE_DATA: 'MESSAGE_CONTAINS_SENSITIVE_DATA',
  MESSAGES_ALLOWED_ONLY_ON_ACTIVE_STORIES:
    'MESSAGES_ALLOWED_ONLY_ON_ACTIVE_STORIES',

  // Loading story errors
  UNABLE_TO_LOAD_STORY_DETAILS: 'UNABLE_TO_LOAD_STORY_DETAILS',
  UNABLE_TO_LOAD_STORY_DETAILS_CHECK_CONNECTION:
    'UNABLE_TO_LOAD_STORY_DETAILS_CHECK_CONNECTION',
}

export const FLOW_INTENTS = {
  TIPPING: 'TIPPING',
}

export const PAYMENT_STATUSES = {
  PENDING: 'PENDING',
  UNDER_REVIEW: 'UNDER_REVIEW',
}

export const PAYMENT_PENDING_REASONS = {
  PAYMENT_HOLD: 'PAYMENT_HOLD',
}

export const REGULATORY_PENDING_REASONS = {
  REGULATORY_REVIEW: 'REGULATORY_REVIEW',
}

export const REGULATORY_RULE_TYPES = {
  OFAC: 'OFAC',
}

export const SHIPPING_ADDRESS_COLLECTION_PREFERENCES = {
  HIDE: 'HIDE',
  DEFAULT_TO_NONE: 'DEFAULT_TO_NONE',
  DEFAULT_TO_PRIMARY: 'DEFAULT_TO_PRIMARY',
}

export const SHIPPING_ADDRESS_OPTIONS = {
  NO_ADDRESS_NEEDED: 'noAddressNeeded',
  ADD_ADDRESS: 'handleAddAddress',
}

export const DISCLOSURE_TYPES = {
  PRE_TRANSACTION_REMITTANCE_DISCLOSURES:
    'PRE_TRANSACTION_REMITTANCE_DISCLOSURES',
  POST_TRANSACTION_REMITTANCE_DISCLOSURES:
    'POST_TRANSACTION_REMITTANCE_DISCLOSURES',
  DELAYED_DEBIT_DISCLOSURES: 'DELAYED_DEBIT_DISCLOSURES',
  PAYMENT_HOLD_DISCLOSURES: 'PAYMENT_HOLD_DISCLOSURES',
  USER_AGREEMENT_DISCLOSURES: 'USER_AGREEMENT_DISCLOSURES',
  FOREIGN_TAX_DISCLOSURES: 'FOREIGN_TAX_DISCLOSURES',
  FRAUDULENT_ACTIVITY_DISCLOSURES: 'FRAUDULENT_ACTIVITY_DISCLOSURES',
  PAYMENT_REVIEW_DISCLOSURES: 'PAYMENT_REVIEW_DISCLOSURES',
  DISPLAY_ADD_INSTRUMENT_FEE_DISCLOSURES:
    'DISPLAY_ADD_INSTRUMENT_FEE_DISCLOSURES',
}

export const FRAUD_DISCLOSURE_TYPES = {
  STATE_MANDATED_WARNING: 'STATE_MANDATED_WARNING',
}

export const PAYMENT_REVIEW_DISCLOSURE_TYPES = {
  PAYMENT_CANCELLATION_DISALLOWED: 'PAYMENT_CANCELLATION_DISALLOWED',
}

export const PROFILE_STATUS = {
  SHARE_PROFILES: 'SHARE_PROFILES',
  SIGNUP_FOR_PROFILES: 'SIGNUP_FOR_PROFILES',
  ACTIVATE_PROFILES: 'ACTIVATE_PROFILES',
}

export const SELLER_PROFILE_STATUS = {
  SHARE_SELLER_PROFILE: 'SHARE_SELLER_PROFILE',
  SIGN_UP_FOR_SELLER_PROFILE: 'SIGN_UP_FOR_SELLER_PROFILE',
  ACTIVATE_SELLER_PROFILE: 'ACTIVATE_SELLER_PROFILE',
  INELIGIBLE_FOR_SELLER_PROFILE: 'INELIGIBLE_FOR_SELLER_PROFILE',
}

export const ERROR_AUTH_REQUIRED = 'authRequired'
export const ERROR_MISSING_REQUIRED_PARAM = 'MISSING_REQUIRED_PARAMETER'
export const ERROR_MISSING_REQUIRED_NOTE_FIELD = 'MISSING_REQUIRED_NOTE_FIELD'
export const ERROR_NOTE_TO_RECEIVER_IS_MANDATORY =
  'NOTE_TO_RECEIVER_IS_MANDATORY'

export const NOTE_VARIANTS = {
  CORE_MARKETS: 'CORE_MARKETS',
  GLOBAL_MARKETS: 'GLOBAL_MARKETS',
  THAILAND: 'THAILAND',
}

export const GROWTH_PRODUCT_FLOWS = {
  SEND_MONEY: 'send_money',
}
export const REQUIRED_FLOW_ATTRIBUTES = { NOTE_TO_RECEIVER: 'NOTE_TO_RECEIVER' }

export const SUMMARY_PAGE_URL = '/myaccount/summary'

export const REQUEST_MAX_CHAR_LIMIT = 1500

export const NUM_TOP_CONTACTS = 7

export const SEARCH_INPUT_WIDTH = 606

export const REQUEST_HEADERS = {
  ACCEPT_LANGUAGE: 'accept-language',
  APPLICATION_CONTEXT: 'PayPal-Application-Context',
}

export const CONTACT_TAGS = {
  MOBILE_CONTACT: 'MOBILE_CONTACT',
}

export const ERROR_MESSAGES = {
  CVV_LENGTH: 'Incorrect CVV length',
  CVV_VERIFICATION: 'CVV Verification failed',
  PARSING_DECRYPTED_DATA: 'Failed to parse decrypted data',
}

export const PAYMENT_ORIGINATION = {
  PAYPAL: 'PAYPAL.COM',
}

export const VISAPLUS = {
  CHECKS_PENDING: 'ELIGIBILITY_CHECKS_PENDING',
  COUNTRY_NOT_SUPPORTED: 'COUNTRY_NOT_SUPPORTED',
  PROFILE_ALREADY_CREATED: 'PROFILE_ALREADY_CREATED',
  ACCOUNT_TYPE_NOT_SUPPORTED: 'ACCOUNT_TYPE_NOT_SUPPORTED',
  CREATE_PROFILE: 'CREATE_PROFILE',
}

export const DEVICE_TYPE = {
  ANDROID: 'AND',
  IOS: 'IOS',
}

export const SPF_TEMPLATES = {
  PUBLIC_PROFILE: 'profilePage',
}
